import { render, staticRenderFns } from "./GeneralJournal.vue?vue&type=template&id=3021228b"
import script from "./GeneralJournal.vue?vue&type=script&lang=js"
export * from "./GeneralJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports